import React, { useContext } from 'react'
import { SocialSigninButtonProps } from './types'
import styles from './SocialSigninButton.module.scss'
import { SessionContext } from 'spa/App'

export const StyledSocialSigninButton: React.FC<SocialSigninButtonProps> = (props: SocialSigninButtonProps) => {
  const session = useContext(SessionContext)
  const authenticityToken = session?.csrf_token || '';
  return (
    <form method="post" action={`/auth/${props.serviceName}`}>
      <input
        type="hidden"
        name="authenticity_token"
        value={authenticityToken}
      />
      <button
        type="submit"
        className={`w-full ${styles.button}`}
      >
        <img className={`w-full ${styles.button}`} src={props.src} alt={props.alt} />
      </button>
    </form>
  )
}
